module.exports = __webpack_public_path__ + "static/img/m_role.7fa1b08.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/bn/m_role.png
// module id = 6Put
// module chunks = 7